import { clinicianSessionOfferModalOpenAtom } from '@/features/settings/billing/billingAtoms';
import { useAtomValue } from 'jotai';
import dynamic from 'next/dynamic';

const ClinicianSessionOfferModalImplementation = dynamic(
  () =>
    import('./clinician-session-offer-modal-implementation').then(
      (mod) => mod.ClinicianSessionOfferModalImplementation
    ),
  { ssr: false, loading: () => null }
);

export function ClinicianSessionOfferModal() {
  const isOpen = useAtomValue(clinicianSessionOfferModalOpenAtom);

  if (!isOpen) {
    return null;
  }

  return <ClinicianSessionOfferModalImplementation />;
}
